import platform from 'platform';
import { formatDateTimeSeconds } from '@instructure/quiz-i18n';
export var extractSessionData = function extractSessionData(sourceData) {
  if (!sourceData) return {
    ipAddress: '',
    browserSessionID: '',
    eventDate: '',
    browserString: '',
    userPlatform: '',
    multipleSessionAttempt: false
  };
  var clientTimestamp = sourceData.getIn(['eventData', 'clientTimestamp']);
  var userAgent = sourceData.getIn(['eventData', 'userAgent']);
  var userPlatform = null;
  if (userAgent) {
    userPlatform = platform.parse(userAgent);
  }
  return {
    ipAddress: sourceData.getIn(['eventData', 'ipAddress']),
    browserSessionID: sourceData.getIn(['eventData', 'browserSessionId']),
    eventDate: clientTimestamp ? formatDateTimeSeconds(clientTimestamp) : '',
    browserString: userPlatform ? "".concat(userPlatform.name, " ").concat(userPlatform.version) : null,
    userPlatform: userPlatform ? userPlatform.os.toString() : null,
    multipleSessionAttempt: sourceData.getIn(['eventData', 'multipleSessionAttempt'], false)
  };
};